import { useCallback } from "react";
import { graphql, useMutation } from "react-relay/hooks";

import type { deleteIdentityProviderMutation } from "__generated__/deleteIdentityProviderMutation.graphql";

export const deleteIdentityProviderCfgMutation = graphql`
  mutation deleteIdentityProviderMutation($identityProviderId: ID!, $connections: [ID!]!) {
    deleteIdentityProviderConfiguration(id: $identityProviderId) {
      identityProviderConfigurationId @deleteEdge(connections: $connections)
      errors
    }
  }
`;

export const useDeleteIdentityProvider = (
  onComplete?: (response: deleteIdentityProviderMutation["response"]) => void,
  onError?: (error: Error) => void
) => {
  const [deleteIdentityProvider, loading] = useMutation<deleteIdentityProviderMutation>(
    deleteIdentityProviderCfgMutation
  );
  const callback = useCallback(
    (identityProviderId: string, connections: string[]) => {
      deleteIdentityProvider({
        variables: {
          identityProviderId,
          connections,
        },
        onCompleted: onComplete,
        onError: onError,
      });
    },
    [deleteIdentityProvider, onComplete, onError]
  );
  return [callback, loading] as const;
};
